import { AsyncJobParams, JobType } from "@repo/db/client";
import { formatAsyncJobMessage } from "@repo/services/models/asyncJobFormatting";
import { Flex, Icon, Text, useTheme } from "@repo/ui";
import { formatTimestampRelative } from "@repo/utils/dateUtils";
import { useInterval } from "@repo/utils/hooks/useInterval";
import { jobTypeMeta } from "../activityLog/jobTypeMeta";
import { useLoggedInUser } from "../contexts/AuthContext";

type EasterEggProps = {
	userEmail: string;
	children: React.ReactNode;
};

const EasterEgg: React.FC<EasterEggProps> = ({ userEmail, children }) => {
	const user = useLoggedInUser();

	if (user?.email.toLowerCase() !== userEmail.toLowerCase()) {
		return null;
	}

	return children;
};

type RunningJobBannerProps = {
	jobType: JobType;
	startedTime: Date;
	jobParams?: AsyncJobParams;
	reasoning?: string;
};

export function RunningJobBanner({
	jobType,
	startedTime,
	jobParams,
	reasoning,
}: RunningJobBannerProps) {
	const theme = useTheme();
	const meta = jobTypeMeta[jobType];
	const message = formatAsyncJobMessage(jobType, jobParams);

	// Update the timestamp every 30 seconds
	const relativeTime = useInterval(
		() => formatTimestampRelative(startedTime),
		30_000,
	);

	return (
		<Flex
			gap="md"
			align="start"
			padding="md"
			style={{
				backgroundColor: theme.colors[meta.backgroundColor],
				borderLeft: `3px solid ${theme.colors[meta.borderColor]}`,
				borderRadius: theme.borderRadiuses.md,
				border: `1px solid ${theme.colors[meta.borderColor]}`,
			}}
		>
			<Icon name={meta.icon} color={meta.textColor} size="sm" shrink={0} />
			<Flex column gap="xs" style={{ flex: 1 }}>
				<Flex align="center" gap="md" style={{ flex: 1 }}>
					<Text size="sm" weight="medium" color={meta.textColor}>
						{message}
					</Text>
					<Text size="sm" color="sand11">
						{relativeTime}
					</Text>
				</Flex>
				{reasoning && (
					<Text size="sm" color={meta.textColor}>
						{reasoning}
					</Text>
				)}
			</Flex>
			{jobType === JobType.AgentNextStep && (
				<EasterEgg userEmail="Kasey.Hernandez@bravohealthsystem.com">
					<Flex column align="center">
						<img
							src="https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcQCgemJZOh_I-c94U7L6ODUFg5LnCiZTZjqF4WKQfep4ahy8xsp"
							width="128"
							height="128"
						/>
					</Flex>
				</EasterEgg>
			)}
		</Flex>
	);
}
